'use client'

import { Dialog, DialogContent } from '@chain-zen/ui'
import { useState } from 'react'

import type { IWorkspace } from '../../types/workspace'
import { Section } from '../shared/section/section'
import { WorkspaceProfilePictureEditor } from '../workspace/workspace-profile-picture-editor'

interface IWorkspacePhotoSectionProps {
  workspaceInfo: IWorkspace
}

/**
 * Workspace photo section component
 * Displays workspace logo and allows for changing it
 */
export const WorkspacePhotoSection = ({ workspaceInfo }: IWorkspacePhotoSectionProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const { displayName, logo, id } = workspaceInfo || {}

  const handleSuccess = () => {
    setIsDialogOpen(false)
  }

  const handleOpenDialog = () => {
    setIsDialogOpen(true)
  }

  const handleDialogChange = (open: boolean) => {
    setIsDialogOpen(open)
  }

  return (
    <>
      <Section
        avatarVariant="square"
        buttonInfo="Please upload a .jpg or .png file"
        buttonName="Change Logo"
        name={displayName || ''}
        onClick={handleOpenDialog}
        profilePhoto={logo || ''}
        sectionTitle="Workspace Logo"
        showAvatarBadge={false}
        showProfilePhotoSection={true}
      />

      <Dialog open={isDialogOpen} onOpenChange={handleDialogChange}>
        <DialogContent className="sm:max-w-[600px] max-h-[95vh] overflow-y-auto">
          <WorkspaceProfilePictureEditor
            defaultAvatarUrl={logo || ''}
            workspaceID={id || ''}
            workspaceName={displayName || ''}
            onSuccess={handleSuccess}
            buttonText="Save"
            title="Change workspace logo"
            subtitle="Upload a logo for your workspace. This will be displayed in various places throughout the application."
            showRemoveButton={Boolean(logo)}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
